<template>
    <div class="modal-overlay" v-if="isOpen">
        <div class="modal-content" @submit.prevent="handleSubmitButton">
            <span class="close-btn" @click="handleCloseButton()" v-if="withTopCloseBtn">
				<font-awesome-icon :icon="['fas', 'fa-x']"/>
            </span>
            <span class="mb-3"><h4>{{ title }}</h4></span>
            <slot></slot>
            <div class="mt-4">
                <button type="button" v-if="withCloseBtn" class="btn btn-secondary sm me-2" @click="handleCloseButton"> {{ closeButtonText }} </button>
                <button type="button" v-if="withSubmitBtn" class="btn btn-primary sm" @click="handleSubmitButton">{{ buttonText }}</button>
            </div>
        </div>
    </div>
</template>

<script src="./ModalScript.vue"/>